import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import GoogleAuthCallback from "./components/GoogleAuthCallback";
import { Toaster } from "sonner";
import "@/index.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { LiveProvider } from "./lib/live";
import LoginPage from "./pages/LoginPage";
import OverviewPage from "./pages/OverviewPage";
import DossiersPage from "./pages/DossiersPage";
import DossierDetailPage from "./pages/DossierDetailPage";
import ConnectionsPage from "./pages/ConnectionsPage";
import ConfigurationPage from "./pages/ConfigurationPage";
import TicketsPage from "./pages/TicketsPage";
import InternalTicketsPage from "./pages/InternalTicketsPage";
import UsersPage from "./pages/UsersPage";
import ChellyBackupPage from "./pages/ChellyBackupPage";
import InboxAiPage from "./pages/InboxAiPage";
import BoiteReponsesPage from "./pages/BoiteReponsesPage";
import SettingsListsPage from "./pages/SettingsListsPage";
import SettingsSchemasPage from "./pages/SettingsSchemasPage";
import StatsPage from "./pages/StatsPage";
import LitigesPage from "./pages/LitigesPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import SavListPage from "./pages/SavListPage";
import SavDetailPage from "./pages/SavDetailPage";
import SavDashboardPage from "./pages/SavDashboardPage";
import PlanningPage from "./pages/PlanningPage";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><OverviewPage /></ProtectedRoute>} />
      <Route path="/dossiers" element={<ProtectedRoute><DossiersPage /></ProtectedRoute>} />
      <Route path="/dossiers/:id" element={<ProtectedRoute><DossierDetailPage /></ProtectedRoute>} />
      <Route path="/connexions" element={<ProtectedRoute><ConnectionsPage /></ProtectedRoute>} />
      <Route path="/configuration" element={<ProtectedRoute><ConfigurationPage /></ProtectedRoute>} />
      <Route path="/configuration/listes" element={<ProtectedRoute><SettingsListsPage /></ProtectedRoute>} />
      <Route path="/configuration/schemas" element={<ProtectedRoute><SettingsSchemasPage /></ProtectedRoute>} />
      <Route path="/tickets" element={<ProtectedRoute><TicketsPage /></ProtectedRoute>} />
      <Route path="/tickets-internes" element={<ProtectedRoute><InternalTicketsPage /></ProtectedRoute>} />
      <Route path="/utilisateurs" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      <Route path="/backup-chelly" element={<ProtectedRoute><ChellyBackupPage /></ProtectedRoute>} />
      <Route path="/reponses" element={<ProtectedRoute><BoiteReponsesPage /></ProtectedRoute>} />
      <Route path="/mails/ia" element={<ProtectedRoute><InboxAiPage /></ProtectedRoute>} />
      <Route path="/statistiques" element={<ProtectedRoute><StatsPage /></ProtectedRoute>} />
      <Route path="/planning" element={<ProtectedRoute><PlanningPage /></ProtectedRoute>} />
      <Route path="/comptabilite" element={<ProtectedRoute><ComingSoonPage title="Comptabilité" /></ProtectedRoute>} />
      <Route path="/sav" element={<ProtectedRoute><SavListPage /></ProtectedRoute>} />
      <Route path="/sav/technique" element={<Navigate to="/sav" replace />} />
      <Route path="/desinstallation" element={<Navigate to="/sav?vue=desinstallation" replace />} />
      <Route path="/desinstallations" element={<Navigate to="/sav?vue=desinstallation" replace />} />
      <Route path="/sav/desinstallation" element={<Navigate to="/sav?vue=desinstallation" replace />} />
      <Route path="/sav/litiges" element={<ProtectedRoute><LitigesPage /></ProtectedRoute>} />
      <Route path="/statistiques/sav" element={<ProtectedRoute><SavDashboardPage /></ProtectedRoute>} />
      <Route path="/sav/tableau-de-bord" element={<Navigate to="/statistiques/sav" replace />} />
      <Route path="/sav/:id" element={<ProtectedRoute><SavDetailPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LiveProvider>
          <AppRoutes />
          <Toaster
            position="top-right"
            theme="light"
            richColors
            closeButton
            toastOptions={{
              style: {
                fontFamily: '"IBM Plex Sans", ui-sans-serif',
                border: "1px solid #E4E6DF",
              },
            }}
          />
        </LiveProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
